import React from 'react';

const Tab = (props) => {
    return (
        <li className="nav-item label-oscura" style={{ cursor: 'pointer' }}>
            <a
                className={props.isActive ? "nav-link active bg-white border-bottom-0 text-dark" : "nav-link text-muted"}
                data-toggle="tab"
                role="tab"
                aria-selected={props.isActive}
                style={{
                    borderBottom: props.isActive ? '3px solid #d32f2f' : '3px solid transparent',
                    transition: 'all 0.2s ease-in-out',
                    borderTop: props.isActive ? '1px solid #dee2e6' : '1px solid transparent',
                    borderLeft: props.isActive ? '1px solid #dee2e6' : '1px solid transparent',
                    borderRight: props.isActive ? '1px solid #dee2e6' : '1px solid transparent',
                }}
            >
                <span className="hidden-sm-up">
                    <i className={props.icon} />
                </span>

                <span className="hidden-xs-down">
                    {props.name}
                </span>
            </a>
        </li >
    );
}

export default Tab;